export default __webpack_public_path__ + "static/media/bad.2c24eb61.svg";